import React from "react";
import { Link } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

const FooterImg = ({ img }) => {
  return (
    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4 image-item">
      <Link to="/media">
        <img src={img} alt="bg-mage" />
        <div className="inner-border">
          <h4>
            Multimedia &nbsp; <Icon.BoxArrowUpRight />
          </h4>
        </div>
      </Link>
    </div>
  );
};

export default FooterImg;
